var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"ot-btn",attrs:{"href":_vm.path,"download":""}},[_c('font-awesome-icon',{staticClass:"mr-2",attrs:{"icon":['fas', 'download']}}),_vm._v(" "+_vm._s(_vm.$t("downloadButton")))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }